import React, { Component } from 'react'
import { loadLibraries } from '../utils/libraries'

export default class LibraryLoaderWrapper extends Component {
  render() {
    let { app, onLoad, useNewRN } = this.props

    if (!app) {
      return null
    }

    return (
      <React.Fragment>
        {[<LibraryLoader key={app.id} app={app} onLoad={onLoad} useNewRN={useNewRN} />]}
      </React.Fragment>
    )
  }
}

class LibraryLoader extends Component {
  notifyLoaded = appId => {
    let { app, onLoad } = this.props

    if (appId !== app.id) {
      return
    }

    onLoad()
  }

  componentDidMount() {
    let { app, useNewRN } = this.props

    loadLibraries(app, useNewRN).then(() => this.notifyLoaded(app.id))
  }

  render() {
    return null
  }
}
